var _rect, _path, _path2, _rect2, _rect3, _rect4, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUser = function SvgUser(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-242 -1364C-242 -1419.23 -197.228 -1464 -142 -1464H31800C31855.2 -1464 31900 -1419.23 31900 -1364V7897C31900 7952.23 31855.2 7997 31800 7997H-142C-197.229 7997 -242 7952.23 -242 7897V-1364Z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-142 -1463H31800V-1465H-142V-1463ZM31899 -1364V7897H31901V-1364H31899ZM31800 7996H-142V7998H31800V7996ZM-241 7897V-1364H-243V7897H-241ZM-142 7996C-196.677 7996 -241 7951.68 -241 7897H-243C-243 7952.78 -197.781 7998 -142 7998V7996ZM31899 7897C31899 7951.68 31854.7 7996 31800 7996V7998C31855.8 7998 31901 7952.78 31901 7897H31899ZM31800 -1463C31854.7 -1463 31899 -1418.68 31899 -1364H31901C31901 -1419.78 31855.8 -1465 31800 -1465V-1463ZM-142 -1465C-197.781 -1465 -243 -1419.78 -243 -1364H-241C-241 -1418.68 -196.676 -1463 -142 -1463V-1465Z",
    fill: "black",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1500,
    height: 900,
    transform: "translate(-30 -149)",
    fill: "#F2F2F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 244,
    height: 900,
    transform: "translate(-30 -149)",
    fill: "#F2F2F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -11,
    width: 216,
    height: 40,
    rx: 4,
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71443 5.99989C9.71443 7.51129 8.65921 8.58535 7.35753 8.58535C6.05585 8.58535 5.00063 7.51129 5.00063 5.99989C5.00063 4.48848 6.05585 3.58535 7.35753 3.58535C8.65921 3.58535 9.71443 4.48848 9.71443 5.99989Z",
    stroke: "#797979",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.6851C13.5 16.2397 11.6818 17.4999 7.5 17.4999C3.31818 17.4999 1.5 16.2397 1.5 14.6851C1.5 13.1305 4.18629 11.8702 7.5 11.8702C10.8137 11.8702 13.5 13.1305 13.5 14.6851Z",
    stroke: "#797979",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1L15.8499 2.83016L17.8532 3.07295L16.3752 4.44684L16.7634 6.42705L15 5.446L13.2366 6.42705L13.6248 4.44684L12.1468 3.07295L14.1501 2.83016L15 1Z",
    stroke: "#797979",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUser);
export default ForwardRef;